import { LoaderFunctionArgs, LoaderFunction, replace } from 'react-router-dom'

import { eventsApi } from '../../../services/events'
import type { AppStore } from '../../../store'

export const eventRegistrationDetailsLoader = (store: AppStore) =>
  (async ({ params }: LoaderFunctionArgs) => {
    const { eventId } = params
    const id = Number.isNaN(Number(eventId)) ? undefined : Number(eventId)

    if (!id) {
      throw new Error('Event id is required')
    }

    const data = await store.dispatch(
      eventsApi.endpoints.getEventRegistrationDetails.initiate(id, { forceRefetch: true })
    )

    if (data.error) {
      return replace(`/events/${eventId}`)
    }
    if (data.data) {
      return data.data
    }
    return replace(`/events/${eventId}`)
  }) satisfies LoaderFunction
